<div>
  <form [formGroup]="thirdFormGroup">
    <div class="mat-flex">
      <mat-form-field>
        <mat-label>Última Fileira</mat-label>
        <mat-select formControlName="row"
                    (selectionChange)="createSeatsArray()">
          <mat-option *ngFor="let row of rowsSelect"
                      [value]="row.value">
            {{ row.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-flex">
      <mat-form-field>
        <mat-label>Número de Colunas</mat-label>
        <input matInput
               placeholder="Número de Colunas"
               formControlName="column"
               type="number"
               min="1"
               max="16"
               required
               (change)="createSeatsArray()">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Máximo assentos por reserva</mat-label>
        <input matInput
               placeholder="Máximo assentos por reserva"
               formControlName="maxSeatBookings"
               type="number"
               min="1"
               max="20"
               required>
      </mat-form-field>
    </div>
    <mat-card appearance="outlined">
      <mat-card-title>
        <p class="title-card">Assentos prioritários (opcional)</p>
      </mat-card-title>
      <mat-card-content>
        <div *ngFor="let seat of seatsSelected; let i = index">
          <app-show-seat-step [seats]="seats"
                              [seatSelect]="select"
                              [index]="i"
                              [disabled]="thirdFormGroup.disabled"
                              [cleanForm]="cleanSeats"
                              (onSelectSeat)="onSelectSeat(i, $event)"
                              (onRemoveSeat)="onRemoveSeat($event)"
                              (onSelectTypeSeat)="onSelectTypeSeat($event)"></app-show-seat-step>
        </div>
        <button mat-raised-button
                [className]="!validAddSeat() ? 'mat-focus-indicator btn-seat disabled mat-raised-button mat-button-base submit-disabled' : 'mat-focus-indicator btn-seat mat-raised-button mat-button-base'"
                id="addSeats"
                (click)="clone()"
                [disabled]="!validAddSeat()">
          + Adicionar assento
        </button>
      </mat-card-content>
    </mat-card>
  </form>
</div>
